import { useEffect } from "react";
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { DEFAULT_CENTER, hasCoords, inspectionIcon } from "@/lib/map";

const Clicker = ({ onPick }) => {
  useMapEvents({ click: (e) => onPick({ lat: +e.latlng.lat.toFixed(6), lng: +e.latlng.lng.toFixed(6) }) });
  return null;
};

const Fixer = ({ point }) => {
  const map = useMap();
  useEffect(() => {
    const t = setTimeout(() => map.invalidateSize(), 250);
    return () => clearTimeout(t);
  }, [map]);
  useEffect(() => {
    if (point) map.setView([point.lat, point.lng], Math.max(map.getZoom(), 14));
  }, [map, point]);
  return null;
};

export const MapPicker = ({ value, onChange }) => {
  const point = hasCoords(value) ? value : null;
  return (
    <div dir="ltr" className="h-56 rounded-lg overflow-hidden border border-slate-200" data-testid="map-picker">
      <MapContainer center={point ? [point.lat, point.lng] : DEFAULT_CENTER} zoom={point ? 14 : 5} className="h-full w-full">
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Clicker onPick={onChange} />
        <Fixer point={point} />
        {point && <Marker position={[point.lat, point.lng]} icon={inspectionIcon("assigned", true)} />}
      </MapContainer>
    </div>
  );
};
